import fetchData, { APIURL, getData, postData } from "../fetch";

/**
 * @typedef {{
 *  id: string 
 *  voucher_no: string
 *  voucher_date: string
 *  method: string
 *  account_id: string
 *  total_amount: number
 *  status: ?string
 *  approver_id: ?string
 *  approved_date: "pending-approval"|"approved"|"processed"
 *  approver: string
 *  account: string|import("./accounts").AccountObject
 *  requisitions: import("./requisitions").RequisitionObject[]
 *  staff_payments: import("./payroll").StaffPaymentObject[]
 * }} PaymentVoucherObject
 */


/**
 * 
 * @param {PaymentVoucherObject} data 
 * @returns {Promise<{code: number, message: string, voucher: PaymentVoucherObject}>}
 */
const createVoucher = data => postData({
    url: `${APIURL}/payment-vouchers`,
    data
})

/**
 * 
 * @param {PaymentVoucherObject} data 
 * @param {string} id
 * @returns {Promise<{code: number, message: string, voucher: PaymentVoucherObject}>}
 */
const updateVoucher = (data, id) => postData({
    url: `${APIURL}/payment-vouchers/${id}`,
    data
})

/**
 * 
 * @param {boolean} getAll If to get the expanded list  
 * @returns {Promise<{code: number, message: string, vouchers: PaymentVoucherObject[]}>}
 */
const getVouchers = (getAll = false) => {

    const obj = { url: `${APIURL}/payment-vouchers` }

    if (getAll) obj.data = { expanded: 1 }

    return getData(obj);
}


/**
 * 
 * @param {string} id 
 * @param {string[]|null} includes 
 * @returns  {Promise<{code: number, message: string, voucher: PaymentVoucherObject}>}
 */
const getVoucher = (id, includes = null) => {

    const obj = { url: `${APIURL}/payment-vouchers/${id}` };

    if (includes) obj.data = { include: includes.join(",") };

    return getData(obj);
}

/**
 * 
 * @param {string} id 
 * @param {"draft"|"awaiting-approval"|"approved"} status 
 * @returns  {Promise<{code: number, message: string, voucher: PaymentVoucherObject}>}
 */
const changeVoucherStatus = (id, status) => postData({ url: `${APIURL}/payment-vouchers/${id}/status/${status}` });


/**
 * 
 * @param {string} id 
 * @returns  {Promise<{code: number, message: string}>}
 */
const deleteVoucher = id => fetchData({ url: `${APIURL}/payment-vouchers/${id}`, method: "DELETE" })


/**
 * 
 * @param {string} id 
 * @returns {Promise<{code: number, message: string}>}
 */
const executePayments = (id) => postData({ url: `${APIURL}/payment-vouchers/${id}/pay` })




export {
    createVoucher,
    getVoucher,
    getVouchers,
    updateVoucher,
    deleteVoucher,
    changeVoucherStatus,
    executePayments,
}